/**
 * 个人中心相关的打点
 */

export default {
  /**
   * 个人中心展示
   * @param {*} show 展示
      head|个人头像展示；
      headhover|个人头像下方hover展示；
      pc|收藏的技巧-电脑版技巧展示;
      phone|收藏的技巧-移动版技巧展示;
      article|收藏的文章页面展示;
      qa|收藏问答页面展示;
      data|我的资料;
      subscription|我的订阅;
      news|消息中心;
   */
  detailsPersonalShow({ show }) {
    this.collect('details_personal_show', { show });
  },

  /**
   * 个人中心点击
   * @param {*} detail 个人中心详情页点击
      collect|我的收藏;
      data|我的资料;
      subscription|我的订阅;
      news|消息中心;
      video|收藏的技巧;
      article|收藏的文章;
      pc|电脑版技巧；
      phone|移动版技巧;
      qa|收藏的问答;
   * @param {*} hover 个人中心头像hover页点击
      head|个人头像点击；
      collect|我的收藏;
      data|我的资料;
      subscription|我的订阅;
      news|消息中心;
      out|退出;
   */
  detailsPersonalClick({ detail, hover }) {
    this.collect('details_personal_click', { detail, hover });
  },
};
